module.exports = __webpack_public_path__ + "media/images/icon_search-97ed74f62a47bea8b8252030fb3095ff.svg";